/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService";

const checklistApi = {

  // 체크리스트 목록 (list)
  fetchList(params) {
    return httpService.get(`/checklist/respondent`, params);
  },

  // 배포된 체크리스트 상세 조회(CheckList Distribution Detail)
  checkListDistributionDetails(params) {
    return httpService.get(`/checklist/distribution/${params.postId}`);
  },
  // Edit comment under a post
  submitCheckList(data, checkListId) {
    return httpService.put(`/checklist/respondent/${checkListId}/submit`, data);
  },

  submitCheckListTemp(data, checkListId) {
    return httpService.put(`/checklist/respondent/${checkListId}/temporary`, data);
  },
  submitCheckListDetails(params) {
    return httpService.get(`/checklist/respondent/${params.postId}`);
  },

  // 상세(Detail)
  checkListDetails(distributionId, storeId, params) {
    return httpService.get(`/checklist/respondent/detail/${distributionId}/${storeId}`, params);
  },

  deleteAnswer(id) {
    return httpService.delete(`/checklist/respondent/${id}`);
  },

  // Answered by the user or not
  answeredByUser(distributionId, storeId) {
    return httpService.get(`/checklist/respondent/exist/${distributionId}/${storeId}`);
  },

  // Reset Question Answer
  resetQuestionAnswered(id) {
    return httpService.put(`/checklist/respondent/${id}/reset`);
  },

  // 체크리스트 진입 및 시작(get Question List)
  getQuestionList(params) {
    return httpService.post(`/checklist/respondent/${params.postId}/enter`);
  },
  // upload image and video
  upload(file) {
    let formData = new FormData();
    formData.append("file", file);
    return httpService.post("/common/attachment", formData)
  },

  // list all comment under a post
  listComments(postParams, params) {
    return httpService.get(`/checklist/respondent/${postParams.postId}/comment`, params);
  },

  boardDetails(params) {
    return httpService.get(`/board/${params.boardId}/article/${params.postId}`);
  },

  boardAuth() {
    return httpService.get(`/checklist/respondent/auth`);
  },

  // add comment under a post
  commentPost(params, commentvalue) {
    return httpService.post(`/checklist/respondent/${params.postId}/comment`, commentvalue);
  },

  // Edit comment under a post
  commentEdit(params, editCommentValue, id) {
    return httpService.put(`/checklist/respondent/${params.postId}/comment/${id}`, editCommentValue);
  },

  // 2Level Reply Comment 
  postReply(params, originId, replyValue) {
    return httpService.post(`/checklist/respondent/${params.postId}/comment/${originId}`, replyValue)
  },

  // 2Level Reply Edit Comment
  editReply(params, replyEditId, replyEditValue) {
    return httpService.put(`/checklist/respondent/${params.postId}/comment/${replyEditId}`, replyEditValue)
  },

  // 1Level OR 2Level Comment Report 
  reportComment(params, id) {
    return httpService.post(`/checklist/respondent/${params.postId}/comment/${id}/report`, params)
  },

  // 1Level OR 2Level Comment Delete 
  deleteComment(params, id) {
    return httpService.delete(`/checklist/respondent/${params.postId}/comment/${id}`)
  },

  reportPost(params) {
    return httpService.post(`/board/${params.boardId}/article/${params.postId}/report`)
  },

  // delete post
  deletePost(params) {
    return httpService.delete(`/board/${params.boardId}/article/${params.postId}`)
  },

  // get Category List for post
  fetchCategoryList() {
    return httpService.get(`/codes/code/CHECKLIST_TYPE`)
  },

  fetchMember(params) {
    return httpService.get(`/membership/member`, params);
  },

  searchTags(str) {
    return httpService.get(`/common/tag/search?name=${str}`);
  },

  createTags(str) {
    return httpService.post(`/common/tag`, str);
  },

  // Add post
  register(params, boardId) {
    return httpService.post(`/board/${boardId}/article`, params);
  },


  updatePost(id, params, boardId) {
    return httpService.put(`/board/${boardId}/article/${id}`, params);
  },
};

// export const
export default checklistApi;